export default __webpack_public_path__ + "fonts/98f3c176ab871509dd670d86f67cf404.svg";